export type InboxItem = {
  id: string;
  status: InboxItemStatusEn | InboxItemStatusCao;
  title: string;
  orgId: number;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  type: InboxItemType;
  subType?: number;
  aoReference: string | null;
}

export enum InboxItemStatusEn {
  New = 0,
  Active = 1,
  Closed = 2,
}

export enum InboxItemStatusCao {
  New = 0,
  Draft = 1,
  Sent = 2,
}

export enum InboxItemStatusCtr {
  New = 0,
  Active = 1,
  Closed = 2,
}

export enum InboxItemType {
  EventNotification = 0,
  ContactAo = 1,
  Ctr = 2,
}